<template>
  <div>
    <div>
      <el-form
        ref="form"
        :model="form"
        label-position="left"
        label-width="70px"
        size="mini"
      >
        <el-form-item label="时间：">
          <el-date-picker
            v-model="form.dateValue"
            type="datetimerange"
            align="right"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
        <div v-for="(item, index) of form.condidions" :key="item.seq">
          <el-form-item :label="`条件` + (index + 1) + `：`">
            <el-select v-model="item.condition" placeholder="请选择条件">
              <el-option
                v-for="conitionItem in avaiableConditions"
                :key="conitionItem.value"
                :label="conitionItem.label"
                :value="conitionItem.value"
              ></el-option>
            </el-select>
            =
            <el-select
              v-if="getInputTypeByCondition(item.condition) == 'select'"
              filterable
              v-model="item.value"
              placeholder="请选择值"
            >
              <el-option
                v-for="value in getValuesByCondition(item.condition)"
                :key="value.value"
                :label="value.label"
                :value="value.value"
              ></el-option>
            </el-select>
            <el-input
              v-else
              v-model="item.value"
              style="width: 200px"
            ></el-input>
            <el-button
              @click="onClickRemoveConditionBtn(index)"
              style="margin-left: 10px"
              icon="el-icon-delete"
              circle
            ></el-button>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button @click="addCondition()" class="el-icon-plus"
            >添加条件</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="onClickQueryBtn()"
            style="margin-left: 10px"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <el-table
      :data="list"
      border
      size="small"
      style="width: 621px; margin-top: 10px"
      height="600px"
      v-el-table-infinite-scroll="loadMore"
      :infinite-scroll-disabled="list.length == 0"
    >
      <el-table-column prop="zoneId" label="分区" align="center" width="80">
      </el-table-column>
      <el-table-column prop="name" label="昵称" align="center" width="150">
      </el-table-column>
      <el-table-column
        prop="amount"
        label="付费金额（元）"
        align="center"
        width="150"
      >
      </el-table-column>
      <el-table-column prop="aid" label="AID" align="center" width="120">
        <template slot-scope="scope">
          <span>
            <a
              href="javascript:;"
              style="text-decoration: none"
              @click="toRouterPlayerInfoPage('aid', scope.row.aid)"
            >
              {{ scope.row.aid }}</a
            ></span
          >
        </template>
      </el-table-column>
      <el-table-column prop="uid" label="UID" align="center" width="120">
        <template slot-scope="scope">
          <span>
            <a
              href="javascript:;"
              style="text-decoration: none"
              @click="toRouterPlayerInfoPage('uid', scope.row.uid)"
            >
              {{ scope.row.uid }}</a
            ></span
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";

export default {
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const start = new Date(new Date().setHours(0, 0, 0, 0));
              const end = new Date(start.getTime() + 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date(new Date().setHours(0, 0, 0, 0));
              const start = new Date(end.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      list: [], //
      form: {
        condidions: [],
        dateValue: [],
      },
      avaiableConditions: [
        {
          value: "uid",
          label: "UID",
        },
        {
          value: "aid",
          label: "AID",
        },
        {
          value: "zone_id",
          label: "分区",
        },
        {
          value: "exchangeAmount",
          label: "付费金额达到",
        },
      ], // 可用的条件
    };
  },

  async created(e) {
    this.form.dateValue = [
      new Date(new Date().setHours(0, 0, 0, 0)),
      new Date(new Date().setHours(0, 0, 0, 0) + 3600 * 1000 * 24),
    ];
  },

  components: {},

  methods: {
    loadMore() {},
    ms2datetime(ts) {
      return util.ms2datetime(ts);
    },
    /**
     * 查询集合
     */
    async loadList() {
      this.list = [];

      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/queryPayDataOfPlayer`,
          {
            startAt: this.form.dateValue[0].getTime(),
            endAt: this.form.dateValue[1].getTime(),
            conditions: this.form.condidions,
          },
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      let listInResponse = resData.data.list || [];

      this.list = this.list.concat(listInResponse);
    },
    addCondition() {
      this.form.condidions.push({
        condition: "",
        value: "",
      });
    },
    onClickRemoveConditionBtn(index) {
      this.form.condidions.splice(index, 1);
    },
    /**
     * 点击查询按钮
     */
    async onClickQueryBtn() {
      await this.loadList();
    },

    /**
     * 根据条件得到结果集合
     * @param {*} condition
     */
    getValuesByCondition(condition) {
      switch (condition) {
      }

      return null;
    },
    /**
     * 根据条件得到输入框类型
     * @param {*} condition
     */
    getInputTypeByCondition(condition) {
      switch (condition) {
        case "": {
          return "select";
        }
      }
    },

    /**
     * 跳转到玩家详情界面
     * @param {*}
     */
    toRouterPlayerInfoPage(condition, value) {
      let query = {};
      switch (condition) {
        case "uid": {
          query = { uid: value, tab: "playerList" };
          break;
        }
        case "aid": {
          query = { aid: value, tab: "playerList" };
          break;
        }
      }
      query["tab"] = "playerList";
      window.open(
        this.$router.resolve({
          path: "/console/player/playerlist",
          query: query,
        }).href,
        "_blank"
      );
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-table__row td {
  padding: 0px 0;
}
</style>